import React from "react";
import { useNavigate } from "react-router-dom";
import { Images } from "../../utils/imageConstants";

const StatGptNavbar = () => {
  const navigate = useNavigate();
  
  return (
    <div className="main-statgpt-wrap">
    <nav className="statgpt-navbar" role="navigation" aria-label="StatGPT Navigation">
      {/* Left: Back Arrow and Title */}
      <div className="statgpt-navbar-left">
        <button
          className="statgpt-back-button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          type="button"
        >
          <img src={Images.back_arrow} alt="Back" />
        </button>
        <div className="statgpt-logo-wrapper">
          <p className="statgpt-title">StatGPT</p>
        </div>
      </div>

      {/* Right: Search Button */}
      <button
        className="statgpt-search-button"
        aria-label="Search"
        type="button"
      >
        <img src={Images.search_icon} alt="Search" />
      </button>
    </nav>
    </div>
  );
};

export default StatGptNavbar
